import "./serviceGraphics.css";

type PhonePairFrameProps = {
  /** Client name, for alt text. */
  name: string;
  /** Front phone screenshot (full-screen app capture, 1290×2796 ratio). */
  front: string;
  /** Back phone screenshot. */
  back: string;
  /**
   * Plays a live plate scan over the front screen: scan line, the plate gets
   * locked, the toast confirms and the Plate Number field fills in. Positions
   * match /work/vrt-app-scan.jpg. The plate text must match the image.
   */
  livePlate?: string;
};

/**
 * Two real app screenshots in phone frames (Work page). Same drawing system
 * as ServiceGraphic: sized in container units, role tokens only.
 */
const PhonePairFrame = ({ name, front, back, livePlate }: PhonePairFrameProps) => (
  <div className="is-gfx gfx--pair">
    <div className="gfx-phone gfx-pair__back">
      <div className="gfx-phone__screen">
        <img src={back} alt={`${name} app: dashboard`} loading="lazy" />
      </div>
    </div>
    <div className="gfx-phone gfx-pair__front">
      <div className="gfx-phone__screen">
        <div className="gfx-live">
          <img src={front} alt={`${name} app: scanning a licence plate`} loading="lazy" />
          {livePlate && (
            <div className="gfx-live__scan" aria-hidden="true">
              <div className="gfx-live__cam">
                <span className="gfx-live__line" />
                <span className="gfx-live__lock" />
              </div>
              <span className="gfx-live__toast">
                <b>✓</b> Plate found · {livePlate}
              </span>
              <span className="gfx-live__field">
                <span className="gfx-live__typed">{livePlate.replace(/\s/g, "")}</span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default PhonePairFrame;
